import React from 'react';
import { Form, Input, DatePicker } from 'antd';
import locale from 'antd/lib/date-picker/locale/ru_RU';
const { Group } = Input;

const Arrival = ({ form }) => {
  const { getFieldDecorator, getFieldValue } = form;
  const arrivalFromValue = getFieldValue('arrivalFrom');
  const arrivalToValue = getFieldValue('arrivalTo');

  return (
    <Form.Item label="Период подачи:" help={null}>
      <Group compact style={{ width: '100%' }}>
        {getFieldDecorator('arrivalFrom')(
          <DatePicker
            locale={locale}
            disabledDate={startValue =>
              arrivalToValue && startValue.valueOf() > arrivalToValue.valueOf()
            }
            style={{ width: '50%' }}
            placeholder="от"
            format={'DD.MM.YYYY'}
          />
        )}
        {getFieldDecorator('arrivalTo')(
          <DatePicker
            locale={locale}
            style={{ width: '50%' }}
            disabledDate={endValue =>
              arrivalFromValue &&
              endValue.valueOf() <= arrivalFromValue.valueOf()
            }
            placeholder="до"
            format={'DD.MM.YYYY'}
          />
        )}
      </Group>
    </Form.Item>
  );
};

export default Arrival;
